import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export const AudienceRegistration = lazyWithSuspense(async () => import('./RegistrationScreen'));
